import xssFilter from '~/utils/xss-filter';
import { TicketComment, CommentAttachment } from './types';

const parseUserComment = ({ comment }: { comment: TicketComment }) => {
  const commentData = [];
  const message = xssFilter(comment?.body?.replace(/\s+--- Via .+ ---/, ''));
  if (message) {
    commentData.push({
      msg: message,
      timestamp: new Date(comment.created_at).getTime(),
      nick: 'visitor',
      displayName: 'visitor',
    });
  }

  if (comment?.attachments?.length > 0) {
    const attachments = comment?.attachments?.map((attachment: CommentAttachment) => ({
      timestamp: new Date(comment.created_at).getTime(),
      nick: 'visitor',
      displayName: 'visitor',
      imgUrl: attachment?.content_url,
    }));
    commentData.push(...attachments);
  }
  return commentData;
};

export default parseUserComment;
